import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import {
  Banner,
  BannerLeft,
  BannerRight,
  BANNER_VARIANT_PURPLE,
  BannerTitle,
  BannerLink,
  Button,
  BUTTON_VARIANT_NEGATIVE,
  IconMailupShield
} from 'mailup-web-components'
import {
  evalCondition,
  notifyParent,
  sessionStoreGet,
  sessionStoreSet,
} from 'mailup-react-helpers'
import {
  useRecoilCallback,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil'
import {
  bannerMailupShieldState,
  deliverabilityIndexState,
  modalMailupShieldState
} from './recoil/state'
import ModalMailupShield from './ModalMailupShield'
import { STORE_KEY_BANNER_MAILUP_SHIELD_CLOSED } from 'Constants/index'
import { useIntl } from 'react-intl'
import { deliverabilityIndexCallback } from './recoil/callbacks'
import { mailupShieldBannerPendoTrack } from 'Helpers/deliverabilityIndex'

const BannerMailupShield = () => {
  const { show } = useRecoilValue(bannerMailupShieldState)
  const bannerClosed = sessionStoreGet(STORE_KEY_BANNER_MAILUP_SHIELD_CLOSED)
  const setModalMailupShieldState = useSetRecoilState(modalMailupShieldState)
  const setBannerMailupShieldState = useSetRecoilState(bannerMailupShieldState)
  const {
    loaded,
    AlertsData: { Sender: SenderFlag }
  } = useRecoilValue(deliverabilityIndexState)


  const intl = useIntl()

  const resetDeliverabilityIndex = useResetRecoilState(deliverabilityIndexState)
  const initDeliverabilityIndex = useRecoilCallback(
    deliverabilityIndexCallback,
    []
  )

  const init = () => {
    initDeliverabilityIndex()
  }

  useEffect(() => {
    init()

    return () => {
      resetDeliverabilityIndex()
    }
  }, [])

  useEffect(() => {
    if (bannerClosed) {
      setBannerMailupShieldState(prev => ({
        ...prev,
        show: false
      }))
    }
  }, [show])

  const handleCloseBanner = () => {
    setBannerMailupShieldState(prev => ({
      ...prev,
      show: false
    }))
    sessionStoreSet(STORE_KEY_BANNER_MAILUP_SHIELD_CLOSED, true)
  }

  useEffect(() => {
    if (loaded && !mailupShield && SenderFlag) {
      mailupShieldBannerPendoTrack(
        'Deliverability index - Banner Mailup Shield - Impression',
        BANNER_VARIANT_PURPLE
      )
    }
  }, [loaded])

  const mailupShield = evalCondition('co:MAILUPSHIELD')
  const showMshop = evalCondition(
    'NOT c:IsRetailer AND uo:GEST AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP'
  )
  const goToMshop = () => {
    notifyParent('redirectMainFrame', [
      '/console/mshop_Redirector.aspx?t=mshopproddet&cp=MUSH'
    ])
  }
  const handleLinkMore = () => {
    setModalMailupShieldState(prev => ({
      ...prev,
      show: true
    }))
  }

  const renderBanner = variant => (
    <>
      <Banner
        variant={variant}
        onClose={() => handleCloseBanner()}
        icon={<IconMailupShield />}
        show={show}
      >
        <BannerLeft>
          <BannerTitle bannerVariant={variant}>
            {intl.formatMessage({ id: 'Load.MailupShield.BannerTitle' })}
          </BannerTitle>
          <p>
            {intl.formatMessage({
              id: 'Load.MailupShield.BannerDescription'
            })}
          </p>
        </BannerLeft>
        <BannerRight>
          <BannerLink
            bannerVariant={variant}
            onClick={handleLinkMore}
            data-mu-test={`banner-mailupShield-scopri-${variant}`}
          >
            {intl.formatMessage({ id: 'Load.ContentDefaults.ReadMore' })}
          </BannerLink>
          {showMshop && (
            <Button
              kind={BUTTON_VARIANT_NEGATIVE}
              onClick={goToMshop}
              data-mu-test={`banner-mailupShield-buy-${variant}`}
            >
              {intl.formatMessage({ id: 'Load.MailupShield.BannerBuy' })}
            </Button>
          )}
        </BannerRight>
      </Banner>
    </>
  )

  return (
    loaded &&
    !mailupShield &&
    SenderFlag && (
      <>
        <ModalMailupShield />
        {renderBanner(BANNER_VARIANT_PURPLE)}
      </>
    )
  )
}

export default BannerMailupShield
